import { render, staticRenderFns } from "./ProductRemoveView.vue?vue&type=template&id=088441e5&scoped=true"
import script from "./ProductRemoveView.vue?vue&type=script&lang=js"
export * from "./ProductRemoveView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088441e5",
  null
  
)

export default component.exports